import React from 'react'
import cx from 'classnames'
import astrochimp from 'astrochimp'

// import { eventType } from '@/google.js'
// import { logFBEvent } from '@/facebook.js'

const mailchimpURL = `//visitrestore.us3.list-manage.com/subscribe/post?u=500a22ecb2d838cdb0ab7caa4&amp;id=b62ecb8fd7`

class Newsletter extends React.Component {
  constructor() {
    super()
    this.state = {
      submit: false,
      focus: false
    }
  }
  handleSubmit(e) {
    e.preventDefault()
    const form = e.currentTarget

    astrochimp(mailchimpURL, { EMAIL: form.email.value }, (err, data) => {
      if (err) {
        console.log(err)
      } else {
        this.setState({
          submit: true
        })
      }
    })
  }
  render() {
    const {
      placeholder,
      className
    } = this.props
    const {
      submit
    } = this.state
    return (
      <div className='forms'>
        {!submit ? (
          <form className={cx('newsletter rel x', className, {
            'focus': this.state.focus
          })} onSubmit={e => this.handleSubmit(e)}>
            <div className='rel newsletter--inner'>
              <label htmlFor='email' className='hide'>Email</label>
              <input type='email'
                onFocus={() => this.setState({focus: true})}
                onBlur={() => this.setState({focus: false})} 
                id='email' name='email' aria-label='email' className='newsletter__input x p1 rel z1 cb bcw' placeholder={placeholder} />
              <button type='submit' className='cb bcp forms__button-inline abs y z1 right' aria-label='newsletter subscribe'>
                <span>Submit</span>
              </button>
            </div>
          </form>
        ) : (
            <div className='s14 studio o5 cb'>Got it!</div>
          )}
      </div>
    )
  }
}

export default Newsletter
